<template>
  <div>
    <div class="content">
      <div class="contentRit">
        <div class="headBox">
          <div class="name">订单列表</div>
          <div class="cont">
            <a-dropdown>
              <div class="box">
                <div class="text">
                  {{ category_cn }}
                </div>
                <div class="iconfont icon-enter"></div>
              </div>
              <a-menu
                slot="overlay"
                @click="hyClick"
                :selectedKeys="[category_id]"
              >
                <a-menu-item :key="item.id" v-for="item in xzList">{{
                  item.name
                }}</a-menu-item>
              </a-menu>
            </a-dropdown>
          </div>
        </div>
        <div class="contBox">
          <div class="headCont">
            <div class="text w30 dis-cent">订单名称</div>
            <div class="text w15 dis-cent">订单金额</div>
            <div class="text w15 dis-cent">下单时间</div>
            <div class="text w15 dis-cent">订单状态</div>
            <div class="text w15 dis-cent">操作</div>
          </div>
          <div class="cont">
            <Kong v-if="list.length == 0" />
            <div class="contLi" v-for="item in list">
              <div class="text w30 dis-cent">
                <span v-if="item.type == 1 || item.type == 0"
                  >{{ item.setmeal_name }}
                </span>
                <span v-else-if="item.type == 2">
                  招聘会申请:{{ item.recruit_sign.recruitname }}
                </span>
                <span v-else-if="item.type == 3"> 线下广告申请 </span>
                <span v-else-if="item.type == 4"> 成为名企 </span>
                <span v-else-if="item.type == 5"> 首页招聘新闻广告宣传 </span>
              </div>
              <div class="text w15 dis-cent money">{{ item.price }}元</div>
              <div class="text w15 dis-cent">{{ item.create_time }}</div>
              <div class="text w15 dis-cent">
                {{
                  item.is_pay == 0
                    ? "未支付"
                    : item.is_pay == 1
                    ? "已支付"
                    : "已取消"
                }}
              </div>
              <div class="text w15 dis-cent">
                <div class="btn1 dis-cent" v-if="item.is_pay == 0">
                  <a-popconfirm
                    title="是否取消订单"
                    ok-text="是"
                    cancel-text="否"
                    @confirm="delClick(item.id)"
                  >
                    取消订单
                  </a-popconfirm>
                </div>
                <div
                  class="btn dis-cent"
                  v-if="item.is_pay == 0"
                  @click="payClick(item.id)"
                >
                  前往支付
                </div>
                <!-- <div
                  class="btn dis-cent"
                  v-if="item.is_pay == 1"
                  @click="payClick(item.id)"
                >
                  发票下载
                </div> -->
              </div>
            </div>
          </div>
          <div class="fenye" v-if="totalCount > 10">
            <a-pagination
              :default-current="page.pageNo"
              v-model="page.pageNo"
              :total="totalCount"
              :page-size="10"
              @change="pageOnChange"
            />
          </div>
        </div>
        <div class="headBox" v-if="fplist != 0">
          <div class="name">发票管理</div>
        </div>
        <div class="contBox" v-if="fplist != 0">
          <div class="headCont">
            <div class="text w40 dis-cent">发票名称</div>
            <div class="text w30 dis-cent">上传时间</div>
            <div class="text w30 dis-cent">操作</div>
          </div>
          <div class="cont">
            <div class="contLi" v-for="item in fplist">
              <div class="text w40 dis-cent">{{ item.name }}</div>
              <div class="text w30 dis-cent">{{ item.create_time }}</div>
              <div class="text w30 dis-cent">
                <div class="btn dis-cent" @click="xzClick(item.id)">
                  <a :href="$imgUrl + item.resource">点击下载</a>
                </div>
              </div>
            </div>
          </div>
          <div class="fenye" v-if="fptotalCount > 10">
            <a-pagination
              :default-current="fppage.pageNo"
              v-model="fppage.pageNo"
              :total="fptotalCount"
              :page-size="10"
              @change="fppageOnChange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Menu,
  Form,
  Input,
  Dropdown,
  Upload,
  Icon,
  message,
  Popconfirm,
  Modal,
} from "ant-design-vue";
import Kong from "../../component/kong.vue";

export default {
  components: {
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-dropdown": Dropdown,
    "a-textarea": Input.TextArea,
    "a-upload": Upload,
    "a-icon": Icon,
    "a-popconfirm": Popconfirm,
    "a-modal": Modal,
    Kong,
  },
  name: "",
  data() {
    return {
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      list: [],
      totalCount: 0,
      category_cn: "全部状态",
      category_id: "",
      xzList: [
        {
          id: "",
          name: "全部状态",
        },
        {
          id: "0",
          name: "未支付",
        },
        {
          id: "1",
          name: "已支付",
        },
        {
          id: "-1",
          name: "已取消",
        },
      ],
      fpjudge: true,
      fppage: {
        pageNo: 1,
        pageSize: 10,
      },
      fplist: [],
      fptotalCount: 0,
    };
  },
  created() {
    this.listGet();
    this.fplistGet();
  },
  methods: {
    xzClick(id) {
      this.$get("/nozzle/web/company_invoice_down", {
        id: id,
      }).then((res) => {
        console.log(res);
      });
    },
    fppageOnChange(i) {
      this.fppage.pageNo = i;
      this.fplistGet();
    },
    fplistGet() {
      if (!this.fpjudge) {
        return;
      }
      this.fpjudge = false;
      this.$get("/nozzle/web/company_invoice_gets", this.fppage).then((res) => {
        console.log(res);
        this.fpjudge = true;
        if (this.fptotalCount == 0) {
          this.fptotalCount = res.fptotalCount;
        }
        if (res.data) {
          this.fplist = res.data;
        } else {
          this.fplist = [];
        }
      });
    },
    pageOnChange(i) {
      this.page.pageNo = i;
      this.listGet();
    },
    hyClick(e) {
      console.log(e);
      this.category_id = e.key;
      this.totalCount = 0;
      this.page.pageNo = 1;
      this.page.is_pay = e.key;
      this.listGet();
      for (let i = 0; i < this.xzList.length; i++) {
        const e1 = this.xzList[i];
        if (e1.id == e.key) {
          this.category_cn = e1.name;
          this.$forceUpdate();
        }
      }
    },
    jump(id) {
      // this.$router.push({
      //   path: "/gongsi/gsZhpCont",
      //   query: {
      //     id,
      //   },
      // });
      window.open("#/gongsi/gsZhpCont?id=" + id);
    },
    yyClick(id) {
      // this.$router.push({
      //   path: "/zhpMark",
      //   query: {
      //     id,
      //   },
      // });
      window.open("#/zhpMark?id=" + id);
    },
    delClick(id) {
      console.log(id);
      this.$post("/nozzle/web/orderlist_cancel", {
        id,
      }).then((res) => {
        console.log(res.data);
        if (res.data.status == 1) {
          this.$message.success("取消订单成功");
          this.listGet();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    payClick(id) {
      // this.$router.push({
      //   path: "/pay",
      //   query: {
      //     id: id,
      //   },
      // });
      window.open("#/pay?id=" + id);
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/oderlist_gets", this.page).then((res) => {
        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
          }
          this.list = res.data;
        } else {
          this.list = [];
        }
      });
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.content {
  margin: auto;
  margin-top: 15px;
  background-color: #fff;
  border-radius: 10px;
  display: flex;
  height: calc(100vh - 85px);
  width: 1280px;
  .contentLeft {
    width: 350px;
    border-right: 1px solid #ebebeb;
    .cont {
      height: 300px;
    }
    .text {
      color: #9c9c9c;
      padding: 10px 15px;
    }
  }
  .contentRit {
    // width: calc(100% - 350px);
    width: 100%;
    box-sizing: border-box;
    .headBox {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 70px;
      padding: 0 20px;
      .name {
        font-weight: 600;
        font-size: 20px;
      }
      .cont {
        display: flex;
        align-items: center;
        .box {
          margin-left: 20px;
          border-radius: 5px;
          background-color: #eef4fc;
          height: 35px;
          width: 150px;
          display: flex;
          align-items: center;
          cursor: pointer;
          .text {
            width: calc(100% - 20px);
            padding-left: 12px;
            box-sizing: border-box;
          }
          .iconfont {
            font-size: 12px;
          }
        }
      }
    }
    .contBox {
      max-height: calc(50% - 70px);
      overflow: auto;
      box-sizing: border-box;
      padding: 0 20px 20px;
      .headCont {
        background-color: whitesmoke;
        height: 45px;
        display: flex;
        font-weight: 600;
      }
      .cont {
        border: 1px solid whitesmoke;
        box-sizing: border-box;
        .contLi {
          display: flex;
          border-bottom: 1px solid whitesmoke;
          padding: 10px 0;
          .text {
            line-height: 150%;
            padding: 0 15px;
            box-sizing: border-box;
          }
          .money {
            font-weight: 600;
            color: #f50c0c;
          }
          .btn {
            width: 80px;
            height: 35px;
            border-radius: 5px;
            background-color: #0c65eb;
            color: #fff;
            cursor: pointer;
            a {
              color: #fff;
            }
          }
          .btn1 {
            width: 80px;
            height: 35px;
            border-radius: 5px;
            box-sizing: border-box;
            border: 1px solid #ebebeb;
            margin-right: 15px;
            cursor: pointer;
          }
        }
        .contLi:last-child {
          border-bottom: none;
        }
      }
    }
  }
}
.w15 {
  width: 17.5%;
}
</style>
